export default __webpack_public_path__ + "3390c4be046cd0020889cde7e4f5f281.svg";